import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useUnrealizedPerformanceFeesToDate from '../../../../hooks/web3/vault/useUnrealizedPerformanceFeesToDate';

const CommunityUnrealizedPerformanceFeesToDate = () => {
    const { unrealizedPerformanceFeesToDate } = useUnrealizedPerformanceFeesToDate();

    return (
        <Detail
            title={
                <>
                    <span>Unrealized Performance Fees to date</span>
                    <InfoPopUp>
                        Unrealized DAO Rewards are taken from the DAO performance
                        Fee, generated by Spool that has yet to be withdrawn by users.
                    </InfoPopUp>
                </>
            }
            value={
                <>
                    {/* {formatUSD(userBalance ? formatEther(userBalance) : 0, 4)} SPOOL */}
                    ~${formatUSD(unrealizedPerformanceFeesToDate || '0')}
                </>
            }
        />
    );
};

export default CommunityUnrealizedPerformanceFeesToDate;
